export default {
  name: 'RttAddresses',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    handleOutsideClick(e) {
      const { tooltip } = this.$refs;

      if (tooltip && !tooltip.contains(e.target)) {
        this.active = false;
      }
    },
  },
};
